import Vue from 'vue'
import Moment from 'moment'
import fr from './i18n/moment_fr'

Moment.suppressDeprecationWarnings = true
Moment.locale('fr', fr)
window.$moment = Moment
Vue.prototype.$moment = Moment
